//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { useSelector } from 'react-redux';

import { TIKTOK_TAG_US_PHRASES } from '@account-settings/components/rights-requests/constants/rightRequestConstants';
import { useIsMessageMissingTCMessage } from '@uia/rights/hooks/useIsMessageMissingTCMessage';
import { useIsMessageMissingTCUrl } from '@uia/rights/hooks/useIsMessageMissingTCUrl';
import { useRightsHistoricalUrlsQuery } from '@uia/rights/hooks/useRightsHistoricalUrlsQuery';
import { getIsRightsRequestTermsAndConditionsEnabled } from '@uia/rights/selectors/getUIARights';
import { isDefined } from '@utils/filterPredicates';
import {
  hasHashtag,
  hasTagUsPhrase,
} from '@utils/social-text-utils/socialTextUtils';

interface UseHasRightsFormErrorsOptions {
  isTikTokContent?: boolean;
  rightsRequestText?: string;
}

export const useHasRightsFormErrorsQuery = ({
  isTikTokContent = false,
  rightsRequestText,
}: UseHasRightsFormErrorsOptions) => {
  const isRightsRequestTermsAndConditionsEnabled = useSelector(
    getIsRightsRequestTermsAndConditionsEnabled,
  );

  const isMessageMissingTCMessage =
    useIsMessageMissingTCMessage(rightsRequestText);

  const isMessageMissingTCUrl = useIsMessageMissingTCUrl(rightsRequestText);

  const isMessageMissingHashtag = !hasHashtag(rightsRequestText);

  const isMessageMissingTagUs =
    isTikTokContent &&
    isDefined(rightsRequestText) &&
    !hasTagUsPhrase(rightsRequestText, TIKTOK_TAG_US_PHRASES);

  return useRightsHistoricalUrlsQuery(
    (historicalUrls) =>
      (isRightsRequestTermsAndConditionsEnabled && historicalUrls.length < 1) ||
      isMessageMissingTCMessage ||
      isMessageMissingTCUrl ||
      isMessageMissingHashtag ||
      isMessageMissingTagUs,
  );
};
